import React, { useState, useEffect } from 'react';
import { getAuth, createUserWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { Navigate } from 'react-router-dom';
import { getFirestore, doc, setDoc } from "firebase/firestore";
import Footer from './components/Footer';
import './CreateAccount.css';

const firebaseAPIKey = process.env.REACT_APP_FIREBASE_API_KEY;

const firebaseConfig = {
  apiKey: firebaseAPIKey,
  authDomain: "property-ranker.firebaseapp.com",
  projectId: "property-ranker",
  storageBucket: "property-ranker.firebasestorage.app",
  messagingSenderId: "392160926638",
  appId: "1:392160926638:web:32df7465675b7cb785063f",
  measurementId: "G-W9CBC2L5F4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

function CreateAccount({ analytics }) {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [user, setUser] = useState(null);
  const [marketingOptIn, setMarketingOptIn] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleCreateAccount = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const db = getFirestore();
      const userDocRef = doc(db, "userPreferences", user.uid);
      await setDoc(userDocRef, { 
        tier: "basic", 
        marketingOptIn: marketingOptIn
      });

      setMessage("Account created successfully. Redirecting...");
    } catch (error) {
      const friendlyMessage = getErrorMessage(error.code);
      setMessage(`Account creation failed: ${friendlyMessage}`);
    }
  };

  const firebaseErrorMessages = {
    "auth/invalid-email": "The email address is not valid.",
    "auth/user-disabled": "This user account has been disabled.",
    "auth/user-not-found": "No user found with this email. Please check and try again.",
    "auth/wrong-password": "Incorrect password. Please try again.",
    "auth/email-already-in-use": "This email is already in use. Please use another email.",
    "auth/weak-password": "The password is too short, please enter at least 8 characters",
    "auth/operation-not-allowed": "This operation is not allowed. Please contact support.",
    "auth/network-request-failed": "Network error. Please check your connection and try again.",
  };

  function getErrorMessage(errorCode) {
    return firebaseErrorMessages[errorCode] || "Unable to create account. Please try again.";
  }

  if (user) {
    return <Navigate to="/properties" replace />;
  }

  return (
    <div>
    <div className="create-account-container">
      <div className="left-container">
      <div className="form-container">
      <h1><img src='/imgs/domorango.png' alt="Domogogo" className="" style={{maxWidth:"200px",paddingBottom:"30px"}} /></h1>
        <h2>Create Your Account</h2>
        <p>Enter your details below to create a new account.</p>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-field"
        />
        <input
          type="password"
          placeholder="Enter a password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input-field"
        />
        <div className="checkbox-container">
          <input
            type="checkbox"
            checked={marketingOptIn}
            onChange={(e) => setMarketingOptIn(e.target.checked)}
          />
          <span style={{color: 'white', fontSize:'14px', marginTop: '12px', marginBottom:"12px", paddingLeft:"12px", textAlign:"left"}}>Yes, I'm happy for you to send me emails about Domogogo, unsubscribe at any time</span><br/>
        </div>
        <button onClick={handleCreateAccount} className="submit-button">CREATE ACCOUNT</button>
        <div style={{paddingTop:"10px"}}><a href='/login' style={{color:'white'}}>Already got an account? Sign in here</a></div>
        {message && <p className="error-message">{message}</p>}
      </div>
      </div>
      <div 
        className="image-container" 
        style={{ backgroundImage: "url('/imgs/bighouse.png')", backgroundSize: "cover", backgroundPosition: "center" }}
      ></div>
    </div>
    <Footer />
    </div>
  );
}

export default CreateAccount;
